<template>
    <div class="col-12" style="padding-right:0;padding-left:0;">
        <div class="card" style="margin-bottom:0px;">
            <div class="card-header">
                <h4>Stok Opname</h4>
                <span class="closes" @click="closeModal();"><i class="fa fa-times"></i></span>
            </div>
            <div id="modal-body" class="card-body">
                <div class="row">
                    <div class="col-12 col-md-4 col-lg-4">
                        <div class="card">
                            <div class="card-header">
                                <h4>Informasi Stok Opname</h4>
                            </div>
                            <div class="card-body">
                                <div class="form-group">
                                    <label>Tanggal</label>
                                    <vc-date-picker v-model="tanggal_stok_opname" :input-props='{class: "form-control",placeholder: "Masukkan tanggal stok opname",}'/>
                                </div>
                                <div class="form-group">
                                    <label>Catatan</label>
                                    <textarea v-model="catatan" class="form-control"> </textarea>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-md-4 col-lg-4">
                        <div class="card">
                            <div class="card-header">
                                <h4>Informasi Produk</h4>
                            </div>
                            <div class="card-body">
                                <div class="form-group">
                                    <label>Nama Produk</label>
                                    <input type="text" v-model="nama_produk" disabled class="form-control">
                                </div>
                                <div class="form-group">
                                    <label>Kode Produk</label>
                                    <input type="text" v-model="kode_produk" disabled class="form-control">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-md-4 col-lg-4">
                        <div class="card">
                            <div class="card-header">
                                <h4>Informasi stok</h4>
                            </div>
                            <div class="card-body">
                                <div class="form-group">
                                    <label>Kuantitas Tercatat : </label>
                                    {{ kuantitas_tercatat }}
                                </div>
                                <div class="form-group">
                                    <label>Kuantitas Penyesuaian</label>
                                    <input type="text" v-model="kuantitas_penyesuaian" disabled class="form-control">
                                </div>
                                <div class="form-group">
                                    <label>Kuantitas Sekarang</label>
                                    <input type="text" v-model="kuantitas_sekarang" class="form-control">
                                </div>
                                <div class="form-group">
                                    <label>Catatan Stok Opname</label>
                                    <input type="text" v-model="catatan_stok_opname" class="form-control">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card-footer">
                <div class="col-12 text-center">
                    <button @click="goBack()" class="btn btn-outline-danger"><i class="fas fa-times"></i> Batal</button>
                    <button @click="submit()" class="btn btn-outline-success">Submit</button>
                </div>
            </div>
        </div>
    </div>
</template>
<style>
@media(max-height: 720px) {
    #modal-body {
        height: 500px;
        overflow: auto;
    }
}

@media(max-height: 820px) {
    #modal-body {
        height: 500px;
        overflow: auto;
    }
}

@media(max-height: 400px) {
    #modal-body {
        height: 240px;
        overflow: auto;
    }
}

/* The Close Button */
.closes {
  color: #6979EF;
  font-size: 28px;
  font-weight: bold;
  margin-left: auto;
  display: flex;
}

.closes:hover,
.closes:focus {
  color: #000;
  text-decoration: none;
  cursor: pointer;
}

</style>

<script>
export default {
    data() {
        return {
            tanggal_stok_opname : new Date,
            catatan : '',
            nama_produk : '',
            kode_produk : '',
            kuantitas_tercatat : '',
            kuantitas_sekarang : '',
            produkDetail : '',
            catatan_stok_opname : ''
        }
    },
    mounted() {
        this.init();
    },
    methods: {
        init: function() {
            // get Kontak detail
            if(this.id_produk != null) {
                this.$http.post("Produk/getProdukDetail/"+this.id_produk).then(result => {
                    if(result.data.code == '00') {
                        alert('failed get Detail')
                    }
                    else {
                        this.produkDetail = result.data.detail
                        this.nama_produk = this.produkDetail.detail.nama_produk
                        this.kode_produk = this.produkDetail.detail.kode_produk
                        this.kuantitas_tercatat = this.produkDetail.detail.qty_total
                        this.kuantitas_sekarang = this.produkDetail.detail.qty_total
                    }
                }, error => {
                    console.log('gk ok')
                    context.errors = errors;
                });
            }
        },
        goBack: function() {
            this.closeModal();
        },
        submit: function(type) {
            if(this.tanggal_stok_opname == '' || this.tanggal_stok_opname == '') {
                this.$parent.$parent.toastr = {
                    title : 'Warning',
                    message : 'Tanggal Stok Opname Wajib Diisi !',
                    type : 'warning'
                }
                return false
            }

            if(!confirm('Kamu yakin?')){
                return false
            }

            var formsub = new FormData();
            formsub.append('id_produk',this.id_produk)
            formsub.append('tanggal_stok_opname',this.formatDate(this.tanggal_stok_opname))
            formsub.append('catatan',this.catatan)
            formsub.append('kuantitas_sekarang',this.kuantitas_sekarang)
            formsub.append('kuantitas_penyesuaian',this.kuantitas_penyesuaian)
            formsub.append('kuantitas_tercatat',this.kuantitas_tercatat)
            formsub.append('catatan_stok_opname', this.catatan_stok_opname)
            
            this.$http.post("Produk/stokOpnameLite", formsub).then(result => {
                if(result.data.code == '01') {
                    this.$parent.$parent.toastr = {
                        title : 'Success',
                        message: 'Produk stok berhasil diupdate !',
                        type : 'success'
                    }
                    this.$nextTick(function(){
                        this.$parent.closingStokOpname();
                    })
                }
                else {
                    this.$parent.toastr = {
                        title : 'Error',
                        message: 'Produk gagal diupdate !',
                        type : 'error'
                    }                    
                }
			}, error => {
				console.log('gk ok')
					context.errors = errors;
			});
        },
        closeModal: function() {
            this.$parent.showStokOpname = false;
        },
        formatDate(date) {
            var d = new Date(date),
                month = '' + (d.getMonth() + 1),
                day = '' + d.getDate(),
                year = d.getFullYear();

            if (month.length < 2) month = '0' + month;
            if (day.length < 2) day = '0' + day;

            return [year, month, day].join('-');
        },
    },
    computed: {
        'kuantitas_penyesuaian': function() {
            return (this.kuantitas_sekarang - this.kuantitas_tercatat).toFixed(2)
        }
    },
    props: ['id_produk']
}
</script>


// WEBPACK FOOTER //
// src/components/produk/StokOpname.vue